import {includes} from '@shared/helpers/collection'

import {DeliveryAttributeCodeType} from '@web/core/constants'
import {isArrivalGuarantee} from '@web/helpers/policies'

import {DeliveryMethod, DeliveryMethodType} from '../constants'

/** 배송 방법 타입을 결정하는 함수. */
export const getDeliveryMethod = ({
    deliveryAttributeType,
    arrivalGuaranteeDateTime,
    deliverySimulatorProbability,
    deliverySimulatorPredictionDate,
    saleChannelType,
    deliveryMethod,
    deliveryType,
    trackable,
}: {
    deliveryAttributeType?: DeliveryAttributeCodeType
    arrivalGuaranteeDateTime?: number
    deliverySimulatorProbability?: number
    deliverySimulatorPredictionDate?: number
    saleChannelType: string
    deliveryMethod: string
    deliveryType: string
    trackable: boolean
}): DeliveryMethodType => {
    // 도착보장 배송
    if (isArrivalGuarantee(deliveryAttributeType) && arrivalGuaranteeDateTime) {
        if (!trackable) {
            return getNotrackingDeliveryMethod(deliveryMethod)
        }

        if (deliveryType === 'ORIGINAL') {
            return DeliveryMethod.ARRIVAL_GUARANTEE
        }
    }

    // 배송시뮬레이터 배송
    if (deliverySimulatorProbability && deliverySimulatorPredictionDate) {
        if (!trackable) {
            return getNotrackingDeliveryMethod(deliveryMethod)
        }

        if (deliveryType === 'ORIGINAL') {
            return DeliveryMethod.SIMULATOR
        }
    }

    // 장보기, 퀵커머스즉시배달, 퀵커머스픽업
    if (saleChannelType === 'BRANCH') {
        if (deliveryAttributeType === 'QUICK') {
            // 퀵커머스 즉시배달
            return DeliveryMethod.QUICK_COMMERCE_INSTANT
        } else if (deliveryAttributeType === 'PICKUP') {
            // 퀵커머스 픽업
            return DeliveryMethod.QUICK_COMMERCE_PICKUP
        } else {
            // 장보기
            return DeliveryMethod.BRANCH_DELIVERY
        }
    }

    // 일반배송, 지정방문택배(c2c), 편의점택배예약(c2c)
    if (trackable && isNormalDelivery(deliveryMethod)) {
        return DeliveryMethod.DELIVERY
    }

    if (!trackable) {
        return getNotrackingDeliveryMethod(deliveryMethod)
    }

    return DeliveryMethod.DELIVERY
}

// 일반택배, 지정방문택배(c2c), 편의점택배예약(c2c) 여부
function isNormalDelivery(method: string) {
    return includes(method, ['DELIVERY', 'DELIVERY_DESIGNATED', 'CONVENIENCE_DELIVERY'])
}

// 추적불가 케이스 배송방법
function getNotrackingDeliveryMethod(method: string) {
    // 직접전달
    if (method === 'DIRECT_DELIVERY') {
        return DeliveryMethod.DIRECT_DELIVERY
    }
    // 퀵서비스 (오토바이 등)
    else if (method === 'QUICK_SVC') {
        return DeliveryMethod.QUICK_SERVICE
    }
    // 방문수령
    else if (method === 'VISIT_RECEIPT') {
        return DeliveryMethod.SELF_PICKUP
    }
    // 추적불가 일반택배
    else {
        return DeliveryMethod.DELIVERY_NO_TRACKING
    }
}
